import { render, staticRenderFns } from "./EditExerciseSingleField.vue?vue&type=template&id=74a66ae2&"
import script from "./EditExerciseSingleField.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseSingleField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports